import { useContext, useEffect, useState } from "react";
import { SettingsContext, ShopContext, TableContext } from "../App";
import "../css/MonoOrderConfirm.css";
import Label from "./Label";
import PickupTickets from "./PickupTickets";
import api from "./api/api";
import currencyFormat from "./functions/functions";
import { renderVariants, renderSubProducts } from "./functions/renderOrderVariants";

function QrOrderConfirm({ order, onClose }) {
	const { settings, setOrdersVisible } = useContext(SettingsContext);
	const { shop } = useContext(ShopContext);
	const { table } = useContext(TableContext);
	const [orderData, setOrderData] = useState(order || {});
	const ticketsActive = settings.selfordering.enable_pickup_receipts_single_order == 1;
	const [recapExpanded, setRecapExpanded] = useState(!ticketsActive);

	useEffect(() => {
		setOrderData(order || {});
	}, [order]);

	useEffect(() => {
		if (!order?.id) return;
		if (order?.number && order?.products && order?.total != null) return;
		loadOrder(order.id);
	}, [order]);

	async function loadOrder(orderId) {
		const response = await api.post("/orders/get/" + orderId + "/");
		if (response.success === 0) {
			alert(response.error);
			return;
		}
		setOrderData(response.data || {});
	}

	return (
		<div
			className="mono-order-confirm test"
			style={{
				backgroundColor: settings.selfordering.color1,
			}}
		>
			<div className="content">
				<h4>
					<Label number={145} />
				</h4>
				{table?.name && (
					<h6 className="room-table">
						{table?.room?.name && (
							<>
								<Label number={153} suffix=": " />
								{table.room.name} -{" "}
							</>
						)}
						<Label number={22} suffix=": " />
						{table.name}
					</h6>
				)}
				<div className="order-number">
					<span>
						<Label number={146} />
					</span>
					<h1>
						{orderData.number ? `N.${orderData.number} - ` : ""}ID:
						{orderData.id || order?.id}
					</h1>
				</div>
				<img
					src={
						"https://api.yellgo.cloud/class/barcode.php?f=png&s=qr&p=0&w=500&h=500&d=" +
						(orderData.id || order?.id || "")
					}
				/>

				<div className="recap">
					<div className="recap-header">
						<div
							className={"recap-header-title" + (ticketsActive ? " recap-toggle" : "")}
							onClick={ticketsActive ? () => setRecapExpanded((v) => !v) : undefined}
						>
							<strong>
								<Label number={148} />
							</strong>
							{ticketsActive && (
								<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ marginLeft: 6, transform: recapExpanded ? "rotate(180deg)" : "none", transition: "transform .2s" }}>
									<path d="m6 9 6 6 6-6"/>
								</svg>
							)}
						</div>
						<div className="recap-header-item">
							<div>
								<Label number={33} />: <strong>{orderData.name}</strong>
							</div>
							{orderData.email && (
								<div>
									Email: <strong>{orderData.email}</strong>
								</div>
							)}
						</div>
					</div>
					{recapExpanded && (
						<div className="recap-products">
							{orderData.products &&
								orderData.products.map((product, index) => {
									return (
										<div className="recap-product" key={index}>
											<div className="recap-product-name">
												{product.name}
												{renderVariants(product.variants)}
												{renderSubProducts(product.products)}
											</div>
											<div className="recap-product-quantity">{product.qty}</div>
											<div className="recap-product-price">
												{currencyFormat(
													product.price,
													false,
													orderData.currency || shop.currency
												)}
											</div>
										</div>
									);
								})}
						</div>
					)}
					{orderData.total != null && (
						<div className="total">
							<span>Totale:</span>{" "}
							{currencyFormat(orderData.total, false, orderData.currency || shop.currency)}
						</div>
					)}
				</div>
				{settings.selfordering.enable_pickup_receipts_single_order == 1 && orderData?.id && (
					<PickupTickets orderId={orderData.id} />
				)}

				<button
					onClick={onClose}
					className="button"
					style={{
						backgroundColor: settings.selfordering.color1,
						color: settings.selfordering.color2,
					}}
				>
					<Label number={147} />
				</button>
				<button
					className="button"
					onClick={() => {
						onClose();
						setOrdersVisible(true);
					}}
					style={{
						backgroundColor: settings.selfordering.color1,
						color: settings.selfordering.color2,
						marginTop: "10px",
					}}
				>
					<Label number={121} />
				</button>
			</div>
		</div>
	);
}

export default QrOrderConfirm;
